import { Injectable } from '@angular/core';
import { OeAppPersonService } from '../shared/oe-app-person.service';
import { OeAppService } from '../shared/oe-app.service';
import { LevelingAction } from '../shared/types/leveling-action';
import { WindowService } from '../shared/window.service';

@Injectable()
export class ActivationRedirectService {
  constructor(
    private readonly oeAppService: OeAppService,
    private readonly oeAppPersonService: OeAppPersonService,
    private readonly windowService: WindowService
  ) {
    this.initializeRedirect();
  }

  redirectToPlacement(): void {
    this.windowService.redirectToHref('/placement-quiz.html');
  }

  redirectToProgressTest(): void {
    this.windowService.redirectToHref('/progress-test.html');
  }

  private initializeRedirect(): void {
    const currentPath = this.windowService.getPathName();
    const isLevelSelectionRoute = currentPath === '/level-selection.html';
    const isPlacementTestRoute = currentPath === '/placement-quiz.html';
    const isPasswordSetupRoute = currentPath.includes('/passwordSetup.html');
    const isActivationPlacementTestEnabled = this.oeAppService.isActivationPlacementTestEnabled();
    const isLoggedIn = !!this.oeAppPersonService.id;

    if (
      isActivationPlacementTestEnabled ||
      !isLoggedIn ||
      isLevelSelectionRoute ||
      isPlacementTestRoute ||
      isPasswordSetupRoute
    ) {
      return;
    }

    switch (this.oeAppPersonService.levelingAction) {
      case LevelingAction.ManualSelection:
        this.windowService.redirectToHref('/level-selection.html');
        break;
      case LevelingAction.PlacementTest:
        this.redirectToPlacement();
        break;
      case LevelingAction.ProgressTestBanner:
        break;
      default:
        break;
    }
  }
}



// WEBPACK FOOTER //
// ./ts/app/activation-redirect/activation-redirect.service.ts